import script from "./ContactConsultModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactConsultModal.vue?vue&type=script&setup=true&lang=js"

import "./ContactConsultModal.vue?vue&type=style&index=0&id=0ffbac45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ffbac45"]])

export default __exports__